export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00534.bbd61d14.png";